/* cf-preview-phone.js - Click Fencing calculators: the fence drawing on a PHONE shows the WHOLE fence.
 *
 * Pete 2026-10-08: "we have serious issues with how our calculators look on mobile devices ... make the
 * calculator easy to use and the fence graphics look good on a mobile", then, shown the options,
 * "yes go with the rows, build it all".
 *
 * What it replaces ON PHONES ONLY (<=749px, calculator pages): cf-preview-scroll.js pinned the drawing
 * to a floor scale so any fence over ~4 m was cut off behind a swipe (6 m showed ~60%, 12 m ~33%), and
 * cf-preview-legible.js re-sized the same svg. Six scripts fought over one drawing every 1.2 s.
 * Now:
 *   - up to ~8 m the whole fence is drawn edge to edge on one line;
 *   - longer fences wrap into ROWS, cut at a post (SVG fences) or between panels (glass), every row at
 *     the same scale, like lines of text;
 *   - labels render at 11px whatever the scale, and labels that would print over each other move down a
 *     line (a 50mm post label beside a bigger label is dropped instead);
 *   - the same treatment on Review & Checkout's Final Preview.
 * Desktop is untouched: on a wider screen this file sets nothing and the older scripts run as before.
 * It must load BEFORE cf-preview-legible / cf-preview-scroll (it claims their guard flags), so it is
 * registered without defer at the top of snippets/meta-tags.liquid.
 * Display only - touches no price, product, quantity or cart line. Roll back: remove that one line.
 */
(function () {
  'use strict';
  if (window.__cfPreviewPhone) return;
  window.__cfPreviewPhone = true;

  var PATHS = ['/pages/glass-fencing', '/pages/fence-calculator', '/pages/blade-fence-calculator',
    '/pages/flat-top-fence-calculator', '/pages/perfmesh-fence'];
  var path = (location.pathname || '/').replace(/\/+$/, '');
  if (PATHS.indexOf(path) === -1) return;
  if (/[?&]crm_embed=1/.test(location.search)) return;
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  // before the viewport meta is parsed a phone reports a 980px layout width, so also trust screen.width
  var PHONE = (MQ && MQ.matches) || (window.screen && screen.width > 0 && screen.width <= 749);
  if (!PHONE) return;            // desktop / tablet: leave everything exactly as it was

  // Retire the two scripts that pin and re-size the drawing (they return early on these flags).
  window.__cfPreviewScrollPatched = true;
  window.__cfPreviewLegibleInstalled = true;
  function whenRoot(fn) { if (document.documentElement && document.head) fn(); else setTimeout(function () { whenRoot(fn); }, 5); }
  whenRoot(function () { document.documentElement.setAttribute('data-cf-phone-preview', '1'); });

  var LABEL_PX = 11;          // rendered size of every drawing label
  var SVG_MIN_SCALE = 0.40;   // below this an SVG fence goes into rows (about 8.5 m)
  var SVG_MAX_H = 175;        // a short fence is not blown up past this height
  var GLASS_ROW_SCALE = 0.05; // px per mm for glass rows (an 1800 panel = 90px)
  var GLASS_MIN_FIT = 0.042;  // below this a glass fence goes into rows (about 6.5 m)

  /* ---------- CSS: full-width drawing band, no inner scroll boxes, no swipe furniture ---------- */
  whenRoot(function () { try {
    var css = document.createElement('style');
    css.id = 'cf-preview-phone-css';
    css.textContent = [
      '@media (max-width:749px){',
      'html[data-cf-phone-preview] body .calculator-page #section-preview{width:auto!important;max-width:none!important;box-sizing:border-box!important;padding-left:4px!important;padding-right:4px!important;overflow-x:hidden!important;overflow-y:visible!important;max-height:none!important;border-left:0!important;border-right:0!important;border-radius:0!important}',
      'html[data-cf-phone-preview] body .calculator-page #section-preview .panels-container{overflow:visible!important;max-width:100%!important}',
      'html[data-cf-phone-preview] body .calculator-page .cfp-rows{display:block;width:100%}',
      'html[data-cf-phone-preview] body .calculator-page .cfp-rows svg{display:block!important;margin:0 auto 10px!important;max-width:100%!important;flex:none!important}',
      'html[data-cf-phone-preview] body .calculator-page .cfp-rows svg:last-child{margin-bottom:0!important}',
      'html[data-cf-phone-preview] #cf-swipe-hint,html[data-cf-phone-preview] [data-cf-band-arrow],html[data-cf-phone-preview] [data-cf-band-fade]{display:none!important}',
      /* glass rows */
      /* glass labels (e.g. "1300mm Rake Panel / 1200mm wide") show in full instead of "1200mm ...": each line
         stays ONE line and spills evenly into the gaps beside the pane. They must not wrap - a 4-line label
         lifts its panel (rows line up on the label's bottom), and the rake glass then sat over its own
         spigots (Pete 9 Oct: "fix the rake label too"). */
      'html[data-cf-phone-preview] body .calculator-page .panel-width > div[style*="ellipsis"]{white-space:nowrap!important;overflow:visible!important;text-overflow:clip!important;max-width:none!important;display:flex!important;justify-content:center!important;line-height:1.2!important}',
      'html[data-cf-phone-preview] body .calculator-page .panel-preview .panel-width{overflow:visible!important;max-width:none!important}',
      'html[data-cf-phone-preview] body .calculator-page .panel-preview{overflow:visible!important}',
      'html[data-cf-phone-preview] .panels-container > .cfp-break{flex:0 0 100%!important;width:100%!important;height:0!important;margin:0!important;padding:0!important}',
      /* Review & Checkout: no 480px inner scroll box, no clipping */
      'html[data-cf-phone-preview] body .calculator-page #final-sections-container,html[data-cf-phone-preview] body .calculator-page #final-sections-container *{max-height:none!important}',
      'html[data-cf-phone-preview] body .calculator-page #final-sections-container .panels-container,html[data-cf-phone-preview] body .calculator-page #final-sections-container .section-panels-container{overflow:visible!important}',
      'html[data-cf-phone-preview] body .calculator-page .final-sections-container .section-panels-container{min-height:0!important;align-items:center!important;overflow:visible!important;padding-top:8px!important}',
      'html[data-cf-phone-preview] body .calculator-page div:has(> #final-sections-container),html[data-cf-phone-preview] body .calculator-page div:has(> .final-sections-container){max-height:none!important;overflow-y:visible!important}',
      'html[data-cf-phone-preview] body .calculator-page .final-sections-container .section-preview-wrapper{padding:10px 4px!important}',
      /* while typing (keyboard up) a tall drawing must not take the whole screen */
      'body.cf-cmk-typing #section-preview{max-height:42vh!important;overflow-y:auto!important}',
      /* the page must not jump when the drawing band pins (Chromium scroll anchoring, Samsung) */
      'html,body{overflow-anchor:none!important}',
      '}'
    ].join('\n');
    document.head.appendChild(css);
  } catch (e) {} });

  function contentWidth(el) {
    if (!el) return 0;
    var cs = getComputedStyle(el);
    return el.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
  }
  function visible(el) {
    if (!el || !el.getClientRects().length) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.right > 0 && r.left < (window.innerWidth + 50);
  }

  /* ======================= SVG fences (blade, flat top, PerfMesh) ======================= */

  function textOf(t) { return (t.textContent || '').replace(/\s+/g, ' ').trim(); }
  function isRotated(t) {
    var tr = (t.getAttribute('transform') || '') + ' ' + (t.parentNode && t.parentNode.getAttribute ? (t.parentNode.getAttribute('transform') || '') : '');
    return /rotate/.test(tr);
  }
  function isPostLabel(t) { return /^50(\s*mm)?$/i.test(textOf(t)); }

  function sig(svg) {
    var ts = svg.querySelectorAll('text'), s = (svg.getAttribute('data-cfp-vb') || svg.getAttribute('viewBox') || '') + '|' + svg.childElementCount + '|';
    for (var i = 0; i < ts.length; i++) s += textOf(ts[i]) + ',';
    return s + '|' + svg.querySelectorAll('*').length;
  }

  function postBars(svg) {
    var out = [], rs = svg.querySelectorAll('rect');
    for (var i = 0; i < rs.length; i++) {
      var w = parseFloat(rs[i].getAttribute('width')), h = parseFloat(rs[i].getAttribute('height'));
      if (w >= 6 && w <= 10 && h > 60) out.push({ x: parseFloat(rs[i].getAttribute('x')) || 0, w: w });
    }
    out.sort(function (a, b) { return a.x - b.x; });
    var dedup = [];
    out.forEach(function (p) { if (!dedup.length || Math.abs(dedup[dedup.length - 1].x - p.x) > 2) dedup.push(p); });
    return dedup;
  }

  function restoreSvg(svg) {
    if (svg.hasAttribute('data-cfp-vb')) svg.setAttribute('viewBox', svg.getAttribute('data-cfp-vb'));
    var ts = svg.querySelectorAll('text');
    for (var i = 0; i < ts.length; i++) {
      var t = ts[i];
      if (t.hasAttribute('data-cfp-y')) t.setAttribute('y', t.getAttribute('data-cfp-y'));
      if (t.hasAttribute('data-cfp-fs')) {
        t.style.removeProperty('font-size');
        t.style.removeProperty('display');
      }
    }
  }

  // Place labels so none prints over another: same-baseline labels that overlap move down a line;
  // a 50mm post label that overlaps anything is dropped (the posts are drawn, every one is 50mm).
  function declutter(svg, fs) {
    var ts = [].slice.call(svg.querySelectorAll('text')).filter(function (t) {
      return !isRotated(t) && textOf(t) && t.style.display !== 'none';
    });
    var boxes = ts.map(function (t) { var b; try { b = t.getBBox(); } catch (e) { b = null; } return { t: t, b: b }; })
      .filter(function (o) { return o.b && o.b.width > 0; });
    // drop post labels that touch any other label (screen boxes, so rotated labels count too)
    var all = [].slice.call(svg.querySelectorAll('text')).filter(function (t) { return textOf(t) && t.style.display !== 'none'; })
      .map(function (t) { return { t: t, r: t.getBoundingClientRect() }; });
    all.forEach(function (o) {
      if (!isPostLabel(o.t) || o.t.style.display === 'none') return;
      for (var i = 0; i < all.length; i++) {
        var p = all[i];
        if (p === o || p.t.style.display === 'none' || !p.r.width) continue;
        if (o.r.left < p.r.right + 1 && p.r.left < o.r.right + 1 && o.r.top < p.r.bottom && p.r.top < o.r.bottom) {
          o.t.style.setProperty('display', 'none', 'important'); break;
        }
      }
    });
    boxes = boxes.filter(function (o) { return o.t.style.display !== 'none'; });
    boxes.sort(function (a, b) { return a.b.x - b.b.x; });
    var placed = [];
    boxes.forEach(function (o) {
      var shift = 0;
      for (var tries = 0; tries < 3; tries++) {
        var hit = false;
        for (var i = 0; i < placed.length; i++) {
          var p = placed[i];
          if (o.b.x < p.x1 + 3 && p.x0 < o.b.x + o.b.width + 3 &&
              o.b.y + shift < p.y1 && p.y0 < o.b.y + shift + o.b.height) { hit = true; break; }
        }
        if (!hit) break;
        shift += fs * 1.15;
      }
      if (shift) {
        var y = parseFloat(o.t.getAttribute('y')) || 0;
        o.t.setAttribute('y', y + shift);
      }
      placed.push({ x0: o.b.x, x1: o.b.x + o.b.width, y0: o.b.y + shift, y1: o.b.y + shift + o.b.height });
    });
  }

  function fitSvg(svg, host, W) {
    if (!svg.hasAttribute('data-cfp-vb')) {
      var vb0 = svg.getAttribute('viewBox');
      if (!vb0) return;
      svg.setAttribute('data-cfp-vb', vb0);
    }
    restoreSvg(svg);
    var old = host.querySelector(':scope > .cfp-rows');
    svg.style.removeProperty('display');

    var vb = svg.getAttribute('data-cfp-vb').split(/[\s,]+/).map(Number);
    var bb; try { bb = svg.getBBox(); } catch (e) { bb = null; }
    var x0 = vb[0], x1 = vb[0] + vb[2], y0 = vb[1], y1 = vb[1] + vb[3];
    if (bb && bb.width > 0) {
      x0 = Math.max(vb[0], bb.x - 4); x1 = Math.min(vb[0] + vb[2], bb.x + bb.width + 4);
      if (x1 - x0 < vb[2] * 0.5) { x0 = vb[0]; x1 = vb[0] + vb[2]; }
      // height from what is actually drawn: the calculator's viewBox carries empty headroom
      y0 = bb.y - 2; y1 = bb.y + bb.height + 2;
    }
    var cw = x1 - x0, vh = y1 - y0;
    var s = W / cw;
    var rows = null;
    if (s < SVG_MIN_SCALE) {
      // cut at posts so no row is wider than W at SVG_MIN_SCALE; then every row shares one scale
      var L = W / SVG_MIN_SCALE, posts = postBars(svg);
      rows = [];
      var start = x0, lastEnd = null, lastPostX = null;
      for (var i = 0; i < posts.length; i++) {
        var p = posts[i], end = p.x + p.w;
        if (p.x <= start + 1) continue;
        if (end - start <= L) { lastEnd = end; lastPostX = p.x; continue; }
        if (lastEnd === null) { rows.push([start, end]); start = p.x; continue; }
        rows.push([start, lastEnd]); start = lastPostX; lastEnd = null; lastPostX = null;
        if (end - start <= L) { lastEnd = end; lastPostX = p.x; }
        else { rows.push([start, end]); start = p.x; }
      }
      if (x1 - start < 30 && rows.length) rows[rows.length - 1][1] = x1;
      else rows.push([start, x1]);
      if (rows.length < 2) rows = null;
      else {
        var maxW = 0; rows.forEach(function (r) { maxW = Math.max(maxW, r[1] - r[0]); });
        s = W / maxW;
      }
    }
    s = Math.min(s, SVG_MAX_H / vh, 1.2);

    // labels at 11px rendered, whatever the scale
    var fs = LABEL_PX / s;
    var ts = svg.querySelectorAll('text');
    for (var k = 0; k < ts.length; k++) {
      var t = ts[k];
      if (!t.hasAttribute('data-cfp-fs')) t.setAttribute('data-cfp-fs', '1');
      if (!t.hasAttribute('data-cfp-y') && t.hasAttribute('y')) t.setAttribute('data-cfp-y', t.getAttribute('y'));
      t.style.setProperty('font-size', fs + 'px', 'important');
      // a narrow cut panel is labelled on its side ("450mm Panel"); at phone size that runs far
      // below the fence, so it reads as the number alone - the same short form every other
      // panel label already uses (cf-preview-labels.js)
      if (isRotated(t)) {
        var mm = /^(\d{2,4})\s*mm\s+panel$/i.exec(textOf(t));
        if (mm) t.textContent = mm[1];
      }
    }
    declutter(svg, fs);
    try {
      var bb2 = svg.getBBox();
      y0 = Math.min(y0, bb2.y - 2); y1 = Math.max(y1, bb2.y + bb2.height + 3);
      // the bigger labels can reach past the fence ends (the rotated 1200mm height mark)
      var nx0 = Math.min(x0, bb2.x - 2), nx1 = Math.max(x1, bb2.x + bb2.width + 2);
      if (rows) {
        rows[0][0] = Math.min(rows[0][0], nx0); rows[rows.length - 1][1] = Math.max(rows[rows.length - 1][1], nx1);
        var mw = 0; rows.forEach(function (r) { mw = Math.max(mw, r[1] - r[0]); });
        s = Math.min(s, W / mw);
      } else {
        x0 = nx0; x1 = nx1; cw = x1 - x0; s = Math.min(s, W / cw);
      }
    } catch (e) {}
    vh = y1 - y0;

    if (old) old.parentNode.removeChild(old);
    if (!rows) {
      svg.setAttribute('viewBox', x0 + ' ' + y0 + ' ' + cw + ' ' + vh);
      svg.style.setProperty('width', Math.round(cw * s) + 'px', 'important');
      svg.style.setProperty('height', Math.round(vh * s) + 'px', 'important');
      svg.style.setProperty('max-width', '100%', 'important');
      svg.style.setProperty('max-height', 'none', 'important');
      svg.style.setProperty('display', 'block', 'important');
      svg.style.setProperty('margin', '0 auto', 'important');
      svg.removeAttribute('data-cfp-rows');
      return;
    }
    // ROWS: one clone of the finished drawing per row, each showing its slice of the fence
    var allTexts = [].slice.call(svg.querySelectorAll('text')).map(function (t) {
      var b; try { b = t.getBBox(); } catch (e) { b = null; }
      return b ? { c: b.x + b.width / 2, x0: b.x, x1: b.x + b.width } : null;
    });
    var shapes = [].slice.call(svg.children).map(function (e) {
      if (e.tagName === 'text' || e.tagName === 'defs') return null;
      var b; try { b = e.getBBox(); } catch (er) { b = null; }
      return b ? { x: b.x, w: b.width } : null;
    });
    var box = document.createElement('div');
    box.className = 'cfp-rows';
    rows.forEach(function (r, ri) {
      var c = svg.cloneNode(true);
      c.removeAttribute('id');
      c.setAttribute('viewBox', r[0] + ' ' + y0 + ' ' + (r[1] - r[0]) + ' ' + vh);
      c.style.cssText = '';
      // the calculator draws its svg with overflow:visible; a row is a window onto part of the fence, so it
      // must clip - otherwise the next panel's blades spill past the row's end post (Pete 9 Oct, Blade test)
      c.removeAttribute('overflow');
      c.style.setProperty('overflow', 'hidden', 'important');
      // the page caps preview svgs at 130px tall; a taller row was squeezed, the fit letterboxed sideways and
      // showed the fence beyond the row's end post - the row keeps its own height
      c.style.setProperty('max-height', 'none', 'important');
      c.style.setProperty('max-width', '100%', 'important');
      c.style.setProperty('width', Math.round((r[1] - r[0]) * s) + 'px', 'important');
      c.style.setProperty('height', Math.round(vh * s) + 'px', 'important');
      c.setAttribute('width', Math.round((r[1] - r[0]) * s));
      c.setAttribute('height', Math.round(vh * s));
      // a shape that mostly belongs to the next row (a gate's highlight reaching over the cut post)
      // shows as a sliver at the row's edge - hide it in this row
      var cks = c.children;
      for (var z = 0; z < cks.length; z++) {
        var sb = shapes[z];
        if (!sb || cks[z].tagName === 'text' || sb.w <= 0) continue;
        var ov = Math.min(sb.x + sb.w, r[1]) - Math.max(sb.x, r[0]);
        if (ov < sb.w * 0.35 && sb.w > 6) cks[z].style.setProperty('display', 'none', 'important');
      }
      var cts = c.querySelectorAll('text');
      for (var q = 0; q < cts.length; q++) {
        var tb = allTexts[q];
        if (!tb) continue;
        var owner = tb.c >= r[0] && (tb.c < r[1] || ri === rows.length - 1);
        // a label cut by the row edge (the post label on a cut post) shows in neither row half-drawn
        var inside = tb.x0 >= r[0] - 0.5 && tb.x1 <= r[1] + 0.5;
        if (!owner || (!inside && !isRotated(cts[q]))) cts[q].style.setProperty('display', 'none', 'important');
      }
      box.appendChild(c);
    });
    svg.setAttribute('data-cfp-rows', rows.length);
    svg.style.setProperty('display', 'none', 'important');
    svg.parentNode.insertBefore(box, svg.nextSibling);
  }

  /* ======================= glass (HTML panels) ======================= */

  function installGlass(P) {
    if (P.__cfpGlass) return;
    P.__cfpGlass = true;
    var origFit = P._previewFitScale;
    if (typeof origFit === 'function') {
      P._previewFitScale = function (panels, gapCount, availablePx) {
        var r = origFit.apply(this, arguments);
        try {
          if (!MQ.matches) return r;
          if (r < GLASS_MIN_FIT) { this.__cfpRowsNext = true; return GLASS_ROW_SCALE; }
        } catch (e) {}
        return r;
      };
    }
    var origAvail = P._previewAvailablePx;
    if (typeof origAvail === 'function') {
      // the calculator took 16px off for padding the phone band no longer has
      P._previewAvailablePx = function (container, sub) {
        var r = origAvail.apply(this, arguments);
        try {
          if (MQ.matches) {
            r = r + 8;
            // a hidden tab (Review) measures as the 800px fallback; on a phone the box is never wider than the screen
            if (r > window.innerWidth - 40) r = window.innerWidth - 56;
          }
        } catch (e) {}
        return r;
      };
    }
    var origRender = P.renderPanelPreview;
    if (typeof origRender === 'function') {
      P.renderPanelPreview = function (container) {
        this.__cfpRowsNext = false;
        var out = origRender.apply(this, arguments);
        try {
          if (this.__cfpRowsNext && container) splitGlassRows(container);
        } catch (e) {}
        this.__cfpRowsNext = false;
        return out;
      };
    }
  }

  // Glass rows stay inside the ONE .panels-container: the calculator reads the panel order back from
  // document.querySelector('.panels-container') (updatePanelData -> customPanelOrder, used by Review),
  // so the panels must never be split across containers. A zero-height full-width break element ends
  // each row; the calculator's own gap/order code only looks at children that hold a .panel-preview.
  function splitGlassRows(container) {
    var pc = container.querySelector(':scope > .panels-container');
    if (!pc) return;
    [].slice.call(pc.querySelectorAll(':scope > .cfp-break')).forEach(function (b) { b.parentNode.removeChild(b); });
    var avail = contentWidth(container) || container.clientWidth;
    if (!avail || avail < 150 || avail > window.innerWidth) avail = Math.min(window.innerWidth - 56, 340);
    var kids = [].slice.call(pc.children);
    if (!kids.length) return;
    // the Review step draws while its tab is still hidden, so fall back to the widths the calculator set
    var widths = kids.map(function (k) { return k.getBoundingClientRect().width || parseFloat(k.style.width) || k.offsetWidth || 13; });
    // units: [leading gap] then (panel wrapper + its trailing gap) pairs
    var units = [], i = 0;
    if (kids[0].classList.contains('gap-preview')) { units.push({ els: [kids[0]], w: widths[0] }); i = 1; }
    for (; i < kids.length; i++) {
      var u = { els: [kids[i]], w: widths[i] };
      if (kids[i + 1] && kids[i + 1].classList.contains('gap-preview')) { u.els.push(kids[i + 1]); u.w += widths[i + 1]; i++; }
      units.push(u);
    }
    var breaksBefore = [], cur = 0, inRow = 0;
    units.forEach(function (u, idx) {
      if (inRow && cur + u.w > avail * 0.94) { breaksBefore.push(u.els[0]); cur = 0; inRow = 0; }
      cur += u.w; inRow++;
    });
    if (!breaksBefore.length) return;
    pc.classList.add('cfp-glass-rows');
    pc.style.setProperty('flex-wrap', 'wrap', 'important');
    pc.style.setProperty('width', '100%', 'important');
    pc.style.setProperty('justify-content', 'flex-start', 'important');
    pc.style.setProperty('row-gap', '14px', 'important');
    breaksBefore.forEach(function (el) {
      var br = document.createElement('div');
      br.className = 'cfp-break';
      br.setAttribute('aria-hidden', 'true');
      pc.insertBefore(br, el);
    });
  }

  /* ======================= driving it ======================= */

  // the drawing runs edge to edge: pull #section-preview out over the page and tab gutters
  function bleed() {
    var p = document.getElementById('section-preview');
    if (!p || !visible(p)) return;
    var host = p.parentElement;
    var r = host.getBoundingClientRect();
    if (!r.width) return;
    var hs = getComputedStyle(host);
    var l = Math.max(0, Math.min(48, Math.round(r.left + (parseFloat(hs.paddingLeft) || 0)) - 4));
    var rr = Math.max(0, Math.min(48, Math.round(window.innerWidth - r.right + (parseFloat(hs.paddingRight) || 0)) - 4));
    if (p.__cfpBleed === l + '/' + rr) return;
    p.__cfpBleed = l + '/' + rr;
    p.style.setProperty('margin-left', -l + 'px', 'important');
    p.style.setProperty('margin-right', -rr + 'px', 'important');
    // glass sizes its panels from the box width when it draws, so draw once more at the new width
    try {
      var gc = window.glassCalculator;
      if (gc && !p.querySelector('svg') && typeof gc.renderSectionPreview === 'function' && gc.state) gc.renderSectionPreview(gc.state.currentSection);
    } catch (e) {}
  }

  function processAll() {
    if (!MQ.matches && window.innerWidth > 749) return;
    try { bleed(); } catch (e) {}
    var hosts = document.querySelectorAll('#section-preview .panels-container, #final-sections-container .panels-container, #final-sections-container .section-panels-container');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var svg = host.querySelector(':scope > svg');
      if (!svg || !visible(host)) continue;
      var pv = host.closest('#section-preview') || host.parentElement;
      var W = Math.floor(Math.min(contentWidth(pv) || pv.clientWidth, window.innerWidth - 16)) - 2;
      if (W < 150) continue;
      var sg = sig(svg) + '|' + W;
      if (svg.__cfpSig === sg) continue;
      try { fitSvg(svg, host, W); } catch (e) { try { console.warn('[cf-preview-phone]', e); } catch (_) {} }
      svg.__cfpSig = sig(svg) + '|' + W;
    }
  }

  /* Glass labels inside the drawing (Pete 9 Oct: "fix the rake label too"). A label shows in full on one
     line (see the CSS above) and may be wider than its pane, so it spills into the gaps either side; the
     first or last pane in a row would push it past the drawing's edge, so nudge it back inside. */
  function clearGlassLabels() {
    var labs = document.querySelectorAll('#section-preview .panel-width, #final-sections-container .panel-width');
    for (var i = 0; i < labs.length; i++) {
      var lw = labs[i];
      if (!lw.getClientRects().length) continue;
      // a label wider than its pane spills both ways; keep it inside the drawing (first / last pane in a row)
      var box = (lw.closest('#section-preview') || lw.closest('#final-sections-container') || document.body).getBoundingClientRect();
      [].slice.call(lw.children).forEach(function (line) {
        line.style.removeProperty('translate');
        var tn = line.firstChild; if (!tn || tn.nodeType !== 3) return;
        var rg = document.createRange(); rg.selectNodeContents(line);
        var tr = rg.getBoundingClientRect();
        var shift = 0;
        if (tr.left < box.left + 2) shift = box.left + 2 - tr.left;
        else if (tr.right > box.right - 2) shift = box.right - 2 - tr.right;
        if (Math.abs(shift) > 0.5) line.style.setProperty('translate', Math.round(shift) + 'px 0', 'important');
      });
    }
  }

  var tA = null, tB = null, tC = null;
  function schedule() {
    clearTimeout(tA); clearTimeout(tB); clearTimeout(tC);
    tA = setTimeout(processAll, 30);
    tB = setTimeout(processAll, 350);        // after the gate / post / cap patches have drawn
    tC = setTimeout(function () { try { clearGlassLabels(); } catch (e) {} }, 2600);   // after cf-rake-align's passes
  }
  function relevant(node) {
    var el = node && (node.nodeType === 1 ? node : node.parentElement);
    if (!el || !el.closest) return false;
    if (el.closest('.cfp-rows')) return false;
    return !!el.closest('#section-preview, #final-sections-container');
  }
  whenRoot(function () { try {
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) { if (relevant(recs[i].target)) { schedule(); return; } }
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  } catch (e) {} });
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;   // the URL bar collapsing is not a re-layout
    lastW = window.innerWidth; schedule();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.tab-button, .nav-btn, button')) schedule();
  }, true);

  var tries = 0;
  (function poll() {
    var C = window.GlassFencingCalculator || (window.glassCalculator && window.glassCalculator.constructor);
    if (C && C.prototype && C.prototype.renderPanelPreview) { try { installGlass(C.prototype); } catch (e) {} return; }
    if (++tries < 400) setTimeout(poll, 25);
  })();
  try { console.log('[cf-preview-phone] installed'); } catch (e) {}
})();
